import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LaminationService } from '@app/shared/services/lamination.service';

import { TempExtrusionService } from '@app/shared/services/temp-extrusion.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

import * as XLSX from 'xlsx';
import { FormsModule } from '@angular/forms';  // <-- Add this


@Component({
  selector: 'app-extrusion-test-table',
  templateUrl: './extrusion-test-table.component.html',
  styleUrls: ['./extrusion-test-table.component.css']
})
export class ExtrusionTestTableComponent implements OnInit {
  
 
   //table
   materialMixEntries: any[] = [];
   currentPage: number = 1;
   itemsPerPage: number = 25;
 
 
   
  
    totalPages: number = 1;
   //  by date
   searchDate: string = '';  // For storing selected date






   tempExtrusionData: any[] = [];  // Store the fetched temp Extrusion data


   // New filter variables
  searchOperator: string = '';
  searchShift: string = '';
  searchMachine: string = '';
  searchClient: string = '';
  searchJobName: string = '';
  searchFromDate: string = '';
  searchToDate: string = '';

  searchTicket: string = '';
 

 constructor( private laminationService: LaminationService, private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute,private tempExtrusionService:TempExtrusionService,) { }

 ngOnInit(): void {
  //  this.loadAllLaminationProductions();

   this.loadTempExtrusionData();  // Load the data when the component initializes
 }

allTempExtrusionData: any[] = [];
// Method to load Temp Extrusion Data
loadTempExtrusionData(): void {
  this.tempExtrusionService.getTempExtrusion().subscribe(
    (data) => {
      console.log('Loaded Temp Extrusion Data:', data);
      if (Array.isArray(data)) {
        // this.tempExtrusionData = data.reverse();  // Reverse the array before assigning it;  // Assign data to the variable;  // Assign data to the variable
         this.allTempExtrusionData = [...data].reverse();
this.tempExtrusionData = [...this.allTempExtrusionData];

        this.totalPages = Math.ceil(this.tempExtrusionData.length / this.itemsPerPage);
        this.updatePaginatedTempExtrusionData();
        this.filterTable();

        //for implementing searchable dropdown
// client name
        this.clientNames = [
        ...new Set(
          this.tempExtrusionData
            .map(x => x.clientName)
            .filter(Boolean)
        )
      ];
      // 
this.shiftNames = [
  ...new Set(
    this.tempExtrusionData
      .map(x => x.shift)
      .filter(Boolean)
  )
];

this.machineNames = [
  ...new Set(
    this.tempExtrusionData
      .map(x => x.machine)
      .filter(Boolean)
  )
];

this.jobNames = [
  ...new Set(
    this.tempExtrusionData
      .map(x => x.jobName)
      .filter(Boolean)
  )
];

this.ticketNumbers = [
  ...new Set(
    this.tempExtrusionData
      .map(x => x.ticketNo)
      .filter(Boolean)
  )
];

this.refNumbers = [
  ...new Set(
    this.tempExtrusionData
      .map(x => x.refNo)
      .filter(Boolean)
  )
];
      // 
      }

      this.cdr.detectChanges();
    },
    (error) => {
      console.error('Error loading Temp Extrusion Data:', error);
    }
  );
}


//for implementing searchable dropdown
clientNames: string[] = [];

shiftNames: string[] = [];
machineNames: string[] = [];
jobNames: string[] = [];
ticketNumbers: string[] = [];
refNumbers: string[] = [];
// 
searchRefNo: string = '';


paginatedTempExtrusionData: any[] = [];

updatePaginatedTempExtrusionData(): void {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.paginatedTempExtrusionData = this.tempExtrusionData.slice(startIndex, endIndex);
}

goToPage(page: number): void {
  if (page < 1 || page > this.totalPages) return;
  this.currentPage = page;
  this.updatePaginatedTempExtrusionData();
}







 // Filter method to apply the filters on the data
 filterTable(): void {
  //  this.loadTempExtrusionData();
  // let filteredData = this.tempExtrusionData;
  let filteredData = [...this.allTempExtrusionData];

   // Log the filter values
  console.log('Search Operator:', this.searchOperator);
  console.log('Search Shift:', this.searchShift);
  console.log('Search Machine:', this.searchMachine);
  console.log('Search Client:', this.searchClient);
  console.log('Search Job Name:', this.searchJobName);
  console.log('Search From Date:', this.searchFromDate);
  console.log('Search To Date:', this.searchToDate);

  // Apply each filter if present
  if (this.searchOperator) {
    filteredData = filteredData.filter(entry => 
      (entry.operator?.toLowerCase() || '').includes(this.searchOperator.toLowerCase())
    );
  }
  if (this.searchShift) {
    filteredData = filteredData.filter(entry => 
      (entry.shift?.toLowerCase() || '').includes(this.searchShift.toLowerCase())
    );
  }
  if (this.searchMachine) {
    filteredData = filteredData.filter(entry => 
      (entry.machine?.toLowerCase() || '').includes(this.searchMachine.toLowerCase())
    );
  }
  if (this.searchClient) {
    filteredData = filteredData.filter(entry => 
      (entry.clientName?.toLowerCase() || '').includes(this.searchClient.toLowerCase())
    );
  }
  if (this.searchJobName) {
    filteredData = filteredData.filter(entry => 
      (entry.jobName?.toLowerCase() || '').includes(this.searchJobName.toLowerCase())
    );
  }
  if (this.searchFromDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) >= new Date(this.searchFromDate)
    );
  }
  if (this.searchToDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) <= new Date(this.searchToDate)
    );
  }
   // Manually filter by From and To Date
   // Manually filter by From and To Date
  //  if (this.searchFromDate) {
  //   const fromDate = this.convertDateFormatForComparison(this.searchFromDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) >= new Date(fromDate)
  //   );
  // }
  // if (this.searchToDate) {
  //   const toDate = this.convertDateFormatForComparison(this.searchToDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) <= new Date(toDate)
  //   );
  // }

  if (this.searchTicket) {
    filteredData = filteredData.filter(entry => 
      (entry.ticketNo?.toLowerCase() || '').includes(this.searchTicket.toLowerCase())
    );
  }

   if (this.searchRefNo) {
  filteredData = filteredData.filter(entry =>
    (entry.refNo?.toLowerCase() || '')
      .includes(this.searchRefNo.toLowerCase())
  );
}

  // Update filtered entries and pagination
  this.tempExtrusionData = filteredData;
  this.totalPages = Math.ceil(this.tempExtrusionData.length / this.itemsPerPage);
  this.updatePaginatedTempExtrusionData();
}

 // Convert date in dd-mm-yyyy format to yyyy-mm-dd for comparison
 convertDateFormatForComparison(date: string): string {
  const [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
}
// Format date from yyyy-mm-dd to dd-mm-yyyy for display
formatDateForDisplay(date: string): string {
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}

clearFilters(): void {
  // Reset all filter variables
  this.searchOperator = '';
  this.searchShift = '';
  this.searchMachine = '';
  this.searchClient = '';
  this.searchJobName = '';
  this.searchFromDate = '';
  this.searchToDate = '';
  this.searchTicket = '';

  // Reload the original data
  this.loadTempExtrusionData(); // This will reset the table to unfiltered data

  // Reset pagination
  this.currentPage = 1;
  this.totalPages = Math.ceil(this.tempExtrusionData.length / this.itemsPerPage);
  this.updatePaginatedTempExtrusionData();

  // Trigger change detection
  this.cdr.detectChanges();
}


// Export to Excel
exportToExcel(): void {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.tempExtrusionData); // Convert data to sheet
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Extrusion Records'); // Append sheet to workbook
  XLSX.writeFile(wb, 'Extrusion_records.xlsx'); // Download as .xlsx file
}



 














 
getTotal(fieldName: string): number {
  return this.tempExtrusionData.reduce((total, entry) => {
    const value = parseFloat(entry[fieldName]) || 0; // Safely parse the value, default to 0 if NaN
    return total + value;
  }, 0);
}




 





printExtrusionData() {
  const printContents =
    document.getElementById('extrusionPrintTable')?.outerHTML;

  if (!printContents) {
    alert('No data available to print.');
    return;
  }

  const printWindow =
    window.open('', '_blank', 'width=1200,height=800');

  if (!printWindow) {
    alert('Please allow pop-ups to print.');
    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <html>
      <head>
        <title>Extrusion Records</title>

        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          h2 {
            text-align: center;
            margin-bottom: 20px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 9px;
          }

          th,
          td {
            border: 1px solid #000;
            padding: 5px;
            text-align: center;
          }

          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }

          tfoot td {
            font-weight: bold;
          }

          @media print {

            body {
              margin: 0;
            }

            table {
              width: 100%;
              page-break-inside: auto;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            thead {
              display: table-header-group;
            }

            tfoot {
              display: table-footer-group;
            }

            @page {
              size: landscape;
              margin: 10mm;
            }
          }
        </style>
      </head>

      <body>

        <h2>Extrusion Records</h2>

        ${printContents}

      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
}

}
